export default theme => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        backgroundColor: theme.palette.background.default,
    },
    // Fullscreen route fills the viewport below the mobile top bar (0 on desktop).
    rootFullscreen: {
        height: 'calc(100vh - var(--app-topbar-height, 0px))',
    },
    // Panel modes (sidebar/widget) fill whatever overlay container hosts them.
    rootPanel: {
        height: '100%',
    },
    body: {
        flex: '1 1 auto',
        display: 'flex',
        overflow: 'hidden',
    },
    main: {
        flex: '1 1 auto',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
});
